var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineBackward5Seconds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.09 16.92c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.29a.781.781 0 0 0 0-1.56h-2.29c-.24 0-.47-.12-.61-.31a.746.746 0 0 1-.1-.68l.76-2.29c.1-.31.39-.51.71-.51h3.06c.41 0 .75.34.75.75s-.34.75-.75.75h-2.52l-.26.79h1.25a2.279 2.279 0 1 1 0 4.56h-2.29zM9.55 5.05A.757.757 0 0 1 9.43 4l1.98-2.47c.26-.32.73-.37 1.05-.12.32.26.37.73.12 1.05L10.6 4.93a.72.72 0 0 1-.58.29.7.7 0 0 1-.47-.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.36 13.11c0-2.07.67-4.06 1.95-5.76a.75.75 0 0 1 1.2.9c-1.08 1.44-1.65 3.12-1.65 4.86 0 4.49 3.65 8.14 8.14 8.14s8.14-3.65 8.14-8.14S16.49 4.97 12 4.97c-.58 0-1.17.07-1.81.22-.4.09-.81-.16-.9-.56-.09-.4.16-.81.56-.9A9.7 9.7 0 0 1 12 3.47c5.31 0 9.64 4.32 9.64 9.64s-4.33 9.64-9.64 9.64c-5.31 0-9.64-4.32-9.64-9.64z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineBackward5Seconds);
export default __webpack_public_path__ + "static/media/vuesax-outline-backward-5-seconds.aee8b7a73d2d8833f193d7d8a172108b.svg";
export { ForwardRef as ReactComponent };